import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {MainLayout} from "../components/layout/MainLayout";
import Shoppers from "../pages/shoppers/Shoppers";
import {EmptyLayout} from "../components/layout/EmptyLayout";
import Shopper from "../pages/shoppers/Shopper";

const basename = '/publicaciones'
export const HOME_URL = '/'
export const SHOPPER__URL = '/:shopperSlug'
export const SHOPPER_PAGE_URL = '/:shopperSlug/:pageNumber'
export const TERMINOS_Y_CONDICIONES_URL = '/'

export function Rutas() {
    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route path={HOME_URL} element={<MainLayout/>}>
                    <Route path={HOME_URL} element={<Shoppers/>}/>
                    <Route path={SHOPPER__URL} element={<Shopper/>}/>
                    <Route path={SHOPPER_PAGE_URL} element={<Shopper/>}/>
                </Route>

                <Route path={TERMINOS_Y_CONDICIONES_URL} element={<EmptyLayout/>}>

                </Route>
            </Routes>
        </BrowserRouter>
    )
}
